export const regionValues = [
  { label: 'All', value: 'all' },
  { label: 'DACH', value: 'de,ch,at' },
  { label: 'UK/US', value: 'gb,ie,us,uk' },
  { label: 'Germany', value: 'de' },
  { label: 'United Kingdom', value: 'uk' },
  { label: 'United States', value: 'us' },
  { label: 'Great Britain', value: 'gb' },
  { label: 'Denmark', value: 'dk' },
  { label: 'Netherlands', value: 'nl' },
  { label: 'Portugal', value: 'pt' },
  { label: 'Romania', value: 'ro' },
  { label: 'Spain', value: 'es' },
  { label: 'Ireland', value: 'ie' },
  { label: 'Italy', value: 'it' },
  { label: 'Australia', value: 'au' },
  { label: 'Canada', value: 'ca' },
  { label: 'Switzerland', value: 'ch' },
  { label: 'Norway', value: 'no' },
  { label: 'Austria', value: 'at' },
]

export const clientValues = [
  { label: 'All', value: 'all' },
  { label: 'Brands', value: true },
  { label: 'Publishers', value: false },
]

export const statusValues = [
  { label: 'All', value: 'all' },
  { label: 'Library', value: 'library' },
  { label: 'Automated', value: 'automated' },
  { label: 'BAMS', value: 'bams' },
  { label: 'Others', value: 'others' },
]



// WEBPACK FOOTER //
// ./src/components/PollCopy/constants.js